import { Box, Button } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { UserIntegrationsContext } from "contexts/UserIntegrations";
import { useContext } from "react";

import { getPageName } from "constants/trackingProps";
import { trackEvent } from "utils/tracking";

const CloseDealButton = () => {
  const { userIntegration } = useContext(UserIntegrationsContext);
  const { subscription, setCustomDomainDialog } =
    useContext(SubscriptionContext);

  if (!userIntegration?.isCustomDomain && !subscription?.customEmailData) {
    return (
      <Button
        disableElevation
        variant="contained"
        sx={{
          textTransform: "none",
          backgroundColor: "secondary.dark",
          ml: -2,
          color: "white",
          borderBottomRightRadius: 20,
          borderTopRightRadius: 0,
        }}
        onClick={() => {
          trackEvent("Set up a Professional Email Button Clicked", {
            Source: getPageName(),
          });
          setCustomDomainDialog(true);
        }}
      >
        Set up a Professional Email{" "}
        <Box
          sx={{ ml: 1 }}
          component="i"
          className="fa-regular fa-arrow-up-right-from-square"
        />
      </Button>
    );
  }

  const trackClick = () => {
    trackEvent("How To Close Deal Button Clicked", {
      Source: getPageName(),
    });
  };

  return (
    <Button
      disableElevation
      variant="contained"
      sx={{
        textTransform: "none",
        backgroundColor: "secondary.dark",
        ml: -2,
        color: "white",
        borderBottomRightRadius: 20,
        borderTopRightRadius: 0,
      }}
      href={`https://www.notion.so/hatchways/How-to-Close-a-Brand-Deal-1cb8dbc98c0680e38324d28701dd2f5d?pvs=4`}
      onClick={trackClick}
      target="_blank"
    >
      💡 How To Close Brand Deals{" "}
      <Box
        sx={{ ml: 1 }}
        component="i"
        className="fa-regular fa-arrow-up-right-from-square"
      />
    </Button>
  );
};

export default CloseDealButton;
